<template>
  <div v-bind="$attrs" class="click-me relative group duration-300">
    <div class="relative flex p-8 pb-0 lg:p-16 z-10">
      <div class="max-w-sm">
        <h2 class="text-3xl font-bold mb-2" style="line-height: 1.1;">Minabo 23/24 ab Dezember erhältlich</h2>
        <p>Zwei Stücke, ein Preis und viele Vorteile: Das perfekte Geschenk für sich – und andere.</p>
      </div>
      <div class="flex flex-1 items-center pl-8">
        <!-- <Icon
          class="ml-auto transition duration-300 transform group-hover:translate-x-[33.3%]"
          type="arrow-right"
          size="10"
        /> -->
      </div>
    </div>
    <div class="lg:absolute lg:right-10 lg:top-[50%] lg:translate-y-[-50%] z-0">
      <img class="max-w-full w-[36rem] mx-auto block" src="/media/Miniabo_Mockup.png" alt="Abos">
    </div>
  </div>
</template>

<script>
// import Icon from 'Web/Shared/Icon.vue';
// import Link from 'Web/Shared/Link.vue';

export default {
  inheritAttrs: false,
  components: {
    // Icon,
    // Link,
  }
}
</script>
